import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import CompanyContact from '@business/general/CompanyContact';
import SpaInfoBoxTranslationGenerated from './SpaInfoBoxTranslation.generated';
import SpaInfoBoxTranslation from '../SpaInfoBoxTranslation';


export class SpaInfoBoxGeneratedEntityManager<BT extends SpaInfoBoxTranslationGenerated, B extends SpaInfoBoxGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = SpaInfoBoxTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'SpaInfoBox',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'contactInfo', type: BusinessEntityFieldType.ForeignKey, inputName: 'contactInfoId', inputProperty: 'contactInfo.id', relatedManager: CompanyContact.manager },
				{ name: 'isActive', type: BusinessEntityFieldType.Boolean },
				{ name: 'showOpeningHours', type: BusinessEntityFieldType.Boolean },
				{ name: 'showPrices', type: BusinessEntityFieldType.Boolean },
				{ name: 'orderNo', type: BusinessEntityFieldType.Integer, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'spaInfoBoxes',
            translationsCustomGraphQlFields: 'title,shortDescription,description,descriptionExtra,seoTitle,seoDescription,seoKeywords,slug',
        });
    }

}
export class SpaInfoBoxGenerated<BT extends SpaInfoBoxTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** A contact person/department for the spa info box. If not set, the default contact person/department for the spa page will be used. */
	contactInfo: CompanyContact | null = null;
	/** Indicates if the spa info box is currently active and should be displayed. */
	isActive: boolean = true;
	/** Indicates if the opening hours should be displayed in the spa info box. */
	showOpeningHours: boolean = true;
	/** Indicates if the prices should be displayed in the spa info box. */
	showPrices: boolean = true;
	/** The order number of the entity. This is automatically set by the system. The value is updated automatically when the entity is moved up or down in the list. */
	orderNo: number = 0;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'spaInfoBox';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default SpaInfoBoxGenerated;